
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-timeline",
  "use": "icon-material-timeline-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-timeline\"><path d=\"M112.51-237.37q-31.03 0-53.09-22.14-22.05-22.15-22.05-53.29 0-31.15 22.11-53.36 22.1-22.21 52.86-22.21 5.77 0 11.13.74t14.31 2.74L327.74-575q-2-8.8-2.62-14.16t-.62-11.03q0-31.2 22.3-53.26 22.3-22.05 53.44-22.05 31.15 0 53.2 22.25Q475.5-631 475.5-599.76q0 3.19-3.24 24.19l103.2 103.31q8.58-2 13.94-2.62t10.6-.62 10.72.62 14.06 2.62l150.33-150.09q-2-8.58-2.62-14.06t-.62-11.14q0-31.11 22.23-53.09 22.23-21.99 53.44-21.99 31.22 0 53.16 22.07 21.93 22.08 21.93 53.29 0 31.22-22.02 53.31-22.03 22.09-52.95 22.09-5.77 0-11.25-.62t-14.06-2.62L672.26-424.78q2 8.58 2.62 14.06t.62 11.08q0 30.8-22.18 52.97t-53.33 22.17q-31.14 0-53.32-22.17-22.17-22.17-22.17-53.03 0-5.78.62-11.14t2.62-14.19L425.03-527.74q-8.83 2-14.19 2.62t-11.09.62q-3.18 0-24.18-3.24L184.89-337.15q2 8.56 2.74 13.8t.74 11.01q0 30.76-22.29 52.86-22.28 22.11-53.57 22.11\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-timeline"/>
                </svg>
            );
        };

        Icon.id = "icon-material-timeline";

        export default Icon;
    